<div class="tab-content" id="tabComponentsContent">
  <div
    class="tab-pane fade show active"
    id="labels"
    role="tabpanel"
    aria-labelledby="labels-tab"
  >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="formGroup">
              <div class="row">
                <div class="col-xs-12 col-lg-6 input-trend-search">
                  <input
                    type="search"
                    #searchBox
                    class="form-control"
                    [placeholder]="'customField.list.search' | translate"
                    formControlName="search"
                    (keyup)="search(searchBox.value)"
                  />
                  <span class="mdi mdi-magnify search-icon ml-2"></span>
                </div>

                <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
                  <button
                    type="submit"
                    [matMenuTriggerFor]="menu"
                    class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
                  >
                    <span>
                      {{ labelType }}
                    </span>
                  </button>
                  <mat-menu #menu class="custom-menu-panel">
                    <button mat-menu-item (click)="searchByType(null)">
                      {{ 'customField.list.filterAll' | translate }}
                    </button>
                    @for (type of listTypeField; track $index) {
                      <button mat-menu-item (click)="searchByType(type)">
                        {{
                          type === "TEXT"
                            ? ('customField.list.typeText' | translate)
                            : type === "NUMBER"
                              ? ('customField.list.typeNumber' | translate)
                              : type === "FREETEXT"
                                ? ('customField.list.typeFreeText' | translate)
                                : type === "DATE"
                                  ? ('customField.list.typeDate' | translate)
                                  : "-"
                        }}
                      </button>
                    }
                  </mat-menu>
                </div>

                <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
                  <button class="btn btn-info fw-bold" (click)="add()">
                    {{ 'customField.list.add' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    @if (loadingContent) {
      <content-loading-list />
    }

    @if (pager.total == 0) {
      <empty-records-component
        [message]="'customField.list.emptyMessage' | translate"
        [subMessage]="'customField.list.emptySubMessage' | translate"
        [icon]="'mdi mdi-alert-circle-outline'"
        [labelButton]="'customField.list.add' | translate"
        (emitEvent)="add()"
      />
    }

    @if (!loadingContent && pager.total > 0) {
      <div class="card">
        <div class="card-body table-responsive">
          <table class="table table-hover table-centered mb-0">
            <thead>
              <tr>
                <th class="text-primary-emphasis">{{ 'customField.list.columnName' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'customField.list.columnType' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'customField.list.columnScope' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'customField.list.columnDescription' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'customField.list.columnCreatedAt' | translate }}</th>
                <th><span class="sr-only"></span></th>
              </tr>
            </thead>
            <tbody>
              @for (item of pager.list; track $index) {
                <tr>
                  <td>{{ item.name }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ (item.scope === 'CUSTOMER' ? 'customField.edit.scopeCustomer' : 'customField.edit.scopeContact') | translate }}</td>
                  <td>{{ item.description | truncate: 50 }}</td>
                  <td>
                    <div>
                      <div>
                        <span>{{
                          item.createdAt
                            | timezoneDate
                              : "DD/MM/YYYY"
                              : getTimezoneCompanyCurrentUser()
                        }}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-dropdown-list"
                        [matMenuTriggerFor]="menu"
                      >
                        <i
                          class="mdi mdi-dots-vertical text-primary-emphasis"
                        ></i>
                      </button>

                      <mat-menu #menu="matMenu">
                        <button
                          mat-menu-item
                          tabindex="0"
                          (click)="delete(item)"
                        >
                          {{ 'customField.list.delete' | translate }}
                        </button>
                      </mat-menu>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>

          @if (pager.total > pager.perPage) {
            <paginator [pager]="pager" (onPager)="loadPage($event)" />
          }
        </div>
      </div>
    }
  </div>
</div>
